<template><div><h1>如何提 issue</h1>
<div class="tip">
<p>使用本项目意味着你也有义务帮助其变得更好。</p>
</div>
<p>不要浪费维护者时间。</p>
<p>不要让维护者帮你学习<code>Vue</code>，帮你熟悉<code>vue-loader</code>，甚至帮你写代码。</p>
<p>不要认为随便一句话就能让维护者明白你的意思，我们没有你想象的那么厉害。</p>
<p>不要提没有任何意义的、代码中带有业务逻辑不方便重现的Issue。</p>
<p>直接关闭你的<code>issue</code>不是对你不满，是你提问题方式不对，没有必要再浪费时间说明为什么要关闭你的<code>issue</code>。</p>
<p>马虎的提问，缺少上下文和重现步骤是在浪费彼此时间。</p>
</div></template><script>
export default {
  head: {"title":"如何提 issue | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// issue-144.vue?7c646888